interface IReadOnlyLayout {
  title: string;
  children: React.ReactNode;
}

const ReadOnlyLayout = ({ title, children }: IReadOnlyLayout) => {
  return (
    <div className="p-4 bg-gradient-to-r from-[#C5C3E6] to-[#F5E0F0] min-h-[700px]">
      <div className="bg-gradient-to-r from-[#704BAC] to-[#AC81F1] h-[140px] text-white flex items-center px-12 font-semibold text-lg md:text-3xl">
        {title}
      </div>
      <div className="bg-white min-h-[calc(100vh)] p-12">{children}</div>
    </div>
  );
};
export default ReadOnlyLayout;
